/* Project Import will be here */
import { getErrorObject } from "utilities/utils";
import { getRewardDashboardApi } from "services/rewards/rewards";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    REWARDS_DASHBOARD_REQUEST: "rewardDashboard/REWARDS_DASHBOARD_REQUEST",
    REWARDS_DASHBOARD_SUCCESS: "rewardDashboard/REWARDS_DASHBOARD_SUCCESS",
    REWARDS_DASHBOARD_FAILURE: "rewardDashboard/REWARDS_DASHBOARD_FAILURE",
    SET_SELECTED_REDEEM_TYPE: "rewardDashboard/SET_SELECTED_REDEEM_TYPE",
    SET_CASH_REWARD_POINTS: "rewardDashboard/SET_CASH_REWARD_POINTS",
    RESET_CASH_POINTS: "rewardDashboard/RESET_CASH_POINTS"
};

const initialState = {
    data: {},
    selectedRedeemType: Constants.PRODUCT,
    cashPoints: 0,
    isLoading: false,
    error: null,
};

export const rewardDashboard = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SELECTED_REDEEM_TYPE:
            return {
                ...state,
                selectedRedeemType: action.payload,
            };

        case types.SET_CASH_REWARD_POINTS:
            return {
                ...state,
                cashPoints: action.payload,
            };

        case types.REWARDS_DASHBOARD_REQUEST:
            return {
                ...state,
                isLoading: true
            };

        case types.REWARDS_DASHBOARD_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };

        case types.REWARDS_DASHBOARD_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.RESET_CASH_POINTS:
            return {
                ...initialState
            };

        default:
            return state;
    }
};

/* Set selected redeem option */
export const setSelectedRedeemType = (type) => {
    return async (dispatch) => {
        dispatch({
            type: types.SET_SELECTED_REDEEM_TYPE,
            payload: type
        });
    }
};

/* Set point to cash converter points */
export const setCashPoints = (points) => {
    return async (dispatch) => {
        dispatch({
            type: types.SET_CASH_REWARD_POINTS,
            payload: points
        });
    }
};

/* Reset the cash points */
export const resetCashPoints = () => {
    return dispatch => {
        dispatch({ type: types.RESET_CASH_POINTS });
    };
};

/* Get reward dashboard details */
export const getRewardDashboard = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARDS_DASHBOARD_REQUEST });
        try {
            const response = await getRewardDashboardApi();
            dispatch({
                type: types.REWARDS_DASHBOARD_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.REWARDS_DASHBOARD_FAILURE,
                payload: { error: message }
            });
        }
    }
};